<template>
  <div
      ref="cardRef"
      class="product"
      v-bind="bindContainer"
      v-memo="[
      product.ID,
      inBasket,
      basketItem.fields.QUANTITY,
      totalPrice,
      isAvailableToAdd,
      wasVisible
    ]"
  >
    <a
        class="c-content bg-white"
        :is="bindLinkComponent"
        v-bind="bindLink"
        v-on="bindLinkListeners"
        @click.prevent.stop="onClick"
    >

      <div class="c-row-holder">
        <div :class="view.rowClass" class="c-row">
          <div :class="view.colMediaClass" class="c-media-col">
            <div :class="view.mediaClass" class="c-media flex">

              <q-no-ssr>
                <div class="c-media__top q-px-sm q-pt-sm flex" v-if="wasVisible">
                  <div class="__left">
                    <ProductFlags
                        v-if="flags.length"
                        :items="flags"
                        :product="product"
                        class=""
                    />
                  </div>
                  <div class="__right">
                    <ProductActions
                        :product="product"
                        class="q-ml-auto on-hover"
                    />
                  </div>
                </div>
                <div class="c-media__bottom q-px-sm q-pb-sm flex" v-if="wasVisible">
                  <div class="__left">
                    <ProductModificators
                        v-if="modificatorsByPosition['card-media']"
                        :modificators="modificatorsByPosition['card-media']"
                        :basket-item="basketItem as any"
                    />
                  </div>
                  <div class="__right">
                    <q-btn
                        v-if="product.INGREDIENTS.length"
                        flat
                        :icon="ICONS.pencil"
                        dense
                        color="primary"
                        @click.stop.prevent="onIngredientsEdit"
                        class="on-hover"
                    />
                  </div>
                </div>
              </q-no-ssr>

              <div class="c-thumb q-my-auto full-width">

                <q-img
                    v-if="!debugOptions.disableImages"
                    :src="imageUrl"
                    :srcset="imageSrcset"
                    :sizes="imageSizes"
                    :ratio="4/3"
                    loading="lazy"
                    decoding="async"
                    class="c-thumb-img"
                >
                  <template v-slot:loading>
                    <div class="skeleton-placeholder"></div>
                  </template>
                </q-img>
              </div>
            </div>
          </div>
          <div :class="view.colMainClass" class="c-main">
            <div
                class="flex column q-px-sm q-ml-xs q-mx-md-none q-pt-sm q-pt-md-none q-px-md-md q-pb-sm q-pb-md-md full-height">
              <div
                  class="c-info full-width cursor-pointer"
                  style="position: relative"
              >
                <div class="c-header block q-mb-xs q-mb-md-sm">
                  <div>
                    <h3
                        :class="view.title"
                        class="c-title text-weight-bolder q-ma-none flex no-wrap q-pr-md"
                    >
                      {{ product.NAME }}
                    </h3>
                  </div>

                  <!-- Feature Labels - Requirements: 3.1 -->
                  <div
                      v-if="hasFeatures && false"
                      class="c-feature-labels q-mt-xs flex q-gutter-xs"
                  >
                    <FeatureLabel
                        v-for="feature in productFeatures"
                        :key="feature.ID"
                        :feature="feature"
                    />
                  </div>

                  <div
                      v-if="descTeaser"
                      class="q-mt-xs text-grey-6 s-font-xs s-font-md-sm"
                      v-html="descTeaser"
                  />

                  <ProductSetItems
                      :product="product"
                      :items="setItems"
                      v-if="!!setItems.length"
                  />
                </div>
              </div>

              <div class="c-bottom q-mt-auto full-width">

                <q-no-ssr>
                  <ProductModificators
                      v-if="wasVisible && modificatorsByPosition['card-sale']"
                      :modificators="modificatorsByPosition['card-sale']"
                      :basket-item="basketItem as any"
                      class="q-gutter-md q-pt-sm q-mb-md"
                  />
                  <BasketRuleRequirement
                      v-if="wasVisible && hasBasketRuleRequirements && detailedBasketRuleRequirements.length > 0"
                      mode="detailed"
                      :rule-states="detailedBasketRuleRequirements"
                  />
                  <div v-if="product.IBLOCK_SECTION_ID === 169" class="text-red-7 q-my-sm s-font-xs">
                    Действует по будням с 11:00 до 16:00
                  </div>
                </q-no-ssr>

                <div class="flex items-center no-wrap">
                  <div class="flex items-center q-gutter-xs q-gutter-md-xs q-gutter-lg-sm q-gutter-md-sm col-grow">
                    <div
                        class="c-price leading-none flex"
                        v-if="priceAvailable"
                    >
                      <div
                          class="c-price__discounted leading-none text-weight-bold s-font-md"
                      >
                        <AnimatedNumber :number="totalPrice" append=" ₽"/>
                      </div>
                      <div
                          class="c-price__base price-old s-font-xs leading-none q-ml-sm"
                          v-html="format(calc.priceSource, true, true)"
                          v-if="calc.discountPercent && (!inBasket || viewMode === 'list')"
                      />
                    </div>
                    <div
                        v-if="!inBasket && weight"
                        class="c-measure text-grey-7 leading-none s-font-2xs s-font-sm-xs s-font-md-xs s-font-lg-sm s-font-xl-sm"
                        :class="view.weightClass"
                    >
                      / {{ weight }} гр
                    </div>
                  </div>
                  <q-no-ssr>
                    <template v-if="isAvailableToAdd">
                      <div class="c-sale q-ml-auto">
                        <AddToCartButton
                            v-if="!inBasket"
                            :loading="basketMutating"
                            @click="onBasketAdd"
                            class="s-font-3xl s-font-md-3xl s-font-lg-3xl"
                        />
                        <QuantityInput
                            v-else
                            :model-value="basketItem.fields.QUANTITY"
                            @update:model-value="onBasketQuantity"
                            color="primary"
                            container-border-color="#ce8714"
                            :show-action-tooltip="true"
                            control-class="q-gutter-sm"
                            :input-disable="true"
                            :allow-inc="allowInc"
                        />
                      </div>
                    </template>
                  </q-no-ssr>
                </div>

                <q-no-ssr>
                  <div v-if="false && modificatorsChild.length && basketItem.commited" class="q-mt-sm">
                    <q-btn
                        :icon="ICONS.plusSolid"
                        label="добавить другой"
                        dense
                        flat
                        color="primary"
                        class="full-width --icon-same c-add-another leading-none s-font-xs s-font-md-md q-px-none"
                        no-wrap
                        @click.stop.prevent="onCreateNewBasketItem"
                    />
                  </div>
                </q-no-ssr>

              </div>
            </div>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script setup lang="ts">
import {ICONS} from "@/assets/icons";
import ProductIngredientsModal from "@/components/Shop/ProductCard/ui/ProductIngredientsModal.vue";
import ProductModificators from "@/components/Shop/ProductModificator/ProductModificators.vue";
import AnimatedNumber from "@/components/Ui/AnimatedNumber.vue";
import QuantityInput from "@/components/Ui/QuantityInput.vue";
import {useDebugComponent} from "@/core/composable/useDebugComponent";
import {useAlerts} from "@/core/store/alerts";
import {useDebugStore} from "@/core/store/debug";
import {useCurrency} from "@/modules/shop/store/currency";
import {useVorderTotalStore} from "@/modules/shop/store/vorder-total";
import {useStackRouter} from "@/packages/stack-router/hooks/useStackRouter";
import {storeToRefs} from "pinia";
import {QNoSsr} from "quasar";
import {computed, onMounted, onUpdated, ref, toRefs, useTemplateRef} from "vue";
import {ProductCardProps, useProductView} from "./hooks";
import ProductActions from "./ui/Actions.vue";
import AddToCartButton from "./ui/AddToCartButton.vue";
import BasketRuleRequirement from "./ui/BasketRuleRequirement.vue";
import FeatureLabel from "./ui/FeatureLabel.vue";
import ProductFlags from "./ui/Flags.vue";
import ProductSetItems from "./ui/SetItems.vue";

const props = withDefaults(defineProps<ProductCardProps>(), {
  borderStyle: "all",
  orientation: "vert",
  viewMode: "grid",
});

const {viewMode} = toRefs(props);

// Флаг для отслеживания видимости карточки
const wasVisible = ref(true);
const cardRef = useTemplateRef<HTMLDivElement>('cardRef');
//const isVisible = useElementVisibility(cardRef);


const {
  totalPrice,
  modificatorsByPosition,
  modificators,
  modificatorsChild,
  onClick,
  onGiftSelect,
  product,
  onBasketAdd,
  onBasketQuantity,
  weight,
  basketItem,
  inBasket,
  bindContainer,
  view,
  viewName,
  flags,
  imageUrl,
  imageSrcset,
  imageSizes,
  bindLinkComponent,
  bindLink,
  bindLinkListeners,
  descTeaser,
  basketMutating,
  priceAvailable,
  calc,
  setItems,
  onMouseEnter,
  onMouseLeave,
  hover,
  availableSchedule,
  quantityLimit,
  productAsGlobalModificatorOption,
  isModificatorOption,
  isAvailableToAdd,
  onCreateNewBasketItem,
  hasBasketRuleRequirements,
  detailedBasketRuleRequirements,
  productFeatures,
  hasFeatures
} = useProductView(props, {
  quantityLimit: props.quantityLimit,
  calcOptions: {
    round: true,
  },
  viewModes: {
    "list-hor": {
      rowClass: "row full-height",
      colMediaClass: "col-24",
      colMainClass: "col-24 col-md-grow q-mt-md",
      mediaClass: "",
      title: "s-font-lg s-font-md-xl",
    },
    "grid-hor": {
      rowClass: "row full-height q-col-gutter-x-md",
      colMediaClass: "col-24 col-md-11",
      colMainClass: "col-24 col-md-13 q-mt-sm ",
      mediaClass: "full-height",
      title: "s-font-lg s-font-md-xl s-font-lg-3xl",
    },

    "list-vert": {
      rowClass: "row q-col-gutter-md-none full-height ",
      colMediaClass: "col-8 col-md-auto",
      colMainClass: "col-16 col-md-grow q-mt-sm q-mt-md-md",
      mediaClass: "full-height",
      title: "s-font-sm s-font-md-lg",
    },

    "grid-vert": {
      rowClass: "column full-height",
      colMediaClass: "col-auto",
      colMainClass: "col-grow q-mt-sm q-mt-md-md",
      mediaClass: "",
      title: "s-font-md s-font-md-lg",
      weightClass: "gt-md",
    },
  },
});

const {format} = useCurrency();
const {showAlerts} = useAlerts();

// Debug store для опций отладки
const debugStore = useDebugStore();
const {debugOptions} = storeToRefs(debugStore);

// Для detailed режима ModificatorRequirement
const totalStore = useVorderTotalStore();

// Вычисляем allowInc с учетом quantityLimit
const allowInc = computed(() => {
  if (!quantityLimit) return true;
  return basketItem.value.fields.QUANTITY < quantityLimit;
});

onUpdated(() => {
  //console.log('onUpdated', product.value.ID)
});

onMounted(() => {
  //  console.log('onMounted', product.value.ID)
});

const stackRouter = useStackRouter();

const onIngredientsEdit = () => {
  stackRouter.getStack()?.push(ProductIngredientsModal, {
    product,
    basketItem,
  });
};


useDebugComponent('ProductCardGrid', {collectRenders: true});
</script>

<style scoped lang="scss">
.product {
  // CSS containment для изоляции карточки от остального DOM
  // Используем только layout и style (без paint для избежания белых областей)
  contain: layout style;

  // GPU ускорение для плавного скролла
  transform: translateZ(0);

  // Оптимизация рендеринга
  will-change: auto;

  // iOS Safari: включаем momentum scrolling
  -webkit-overflow-scrolling: touch;
}

.c-content {
  // Дополнительная оптимизация для контента карточки
  // iOS Safari Fix: Force GPU acceleration
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
}

.skeleton-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.c-basket-add {
  cursor: pointer;
  border: 1px solid currentColor;
  border-radius: 8px;
  line-height: 0;

  svg,
  img {
    width: 1em;
    height: 1em;
    fill: currentColor;
  }
}

.c-row-holder {
  height: 100%;
  position: relative;
}

.c-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 10px;
  border: 1px solid #eee;

  // iOS Safari Fix: комбинация решений
  // 1. Force GPU acceleration - исправляет проблему с hit area после скролла
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);

  // 2. Отключаем 300ms delay
  touch-action: manipulation;

  // 3. Делаем элемент "кликабельным" для iOS
  cursor: pointer;

  // 4. Убираем highlight при тапе
  -webkit-tap-highlight-color: transparent;
}


@media (max-width: $breakpoint-sm-max) {
  .c-flag-icon {
    max-width: 26px !important;
  }

  .--viewmode-list.--orientation-vert {

    .c-media {
      padding: 10px 0 10px 10px;
    }

    .c-thumb-img {
      border-radius: 10px;
    }

    .c-favs {
      bottom: 10px;
      left: 0;
      right: auto;
      top: auto;
    }
  }
}

.c-more {
  opacity: 0;
  transform: scale(0.3);
  transition: all 0.6s;
}

.c-media {
  position: relative;
  //background-color: #efefef;
}

/* Стабилизируем поток в вертикальной grid-карточке */
.product.--viewmode-grid.--orientation-vert {
  .c-media {
    flex: 0 0 auto;
  }

  .c-main {
    position: relative;
    z-index: 1;
  }

  .c-media-col {
    aspect-ratio: 1.333;
    width: 100%;
  }
}

.c-media__top {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  display: flex;

  .__left {
  }

  .__right {
    margin-left: auto;
  }
}

.c-media__bottom {
  width: 100%;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 2;
  display: flex;

  .__left {
  }

  .__right {
    margin-left: auto;
  }
}

.c-thumb {
  position: relative;
  overflow: hidden;
  font-size: 0;
  //container-type: inline-size;
}

.c-thumb-img {
  //height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  transition: transform 3s;
}

.on-hover {
  opacity: 0;
  transition: opacity 1s;
}

.product {

  // iOS Safari: hover стили только на desktop
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      .on-hover {
        opacity: 1;
      }

      .c-more {
        opacity: 0.92;
        transform: scale(1);
      }
    }
  }

  &.--orientation-vert {

  }

  @media (max-width: $breakpoint-sm-max) {
    .c-title {
      line-height: 1.3em;
    }
  }

  @media (min-width: $breakpoint-lg-min) {

    // iOS Safari: hover эффект только на desktop с мышью
    @media (hover: hover) and (pointer: fine) {
      &:hover {
        .c-thumb-img {
          transform: scale(1.3);
        }
      }
    }
  }

}

.c-price__discounted {

}

@media (min-width: $breakpoint-md-min) {
  .--viewmode-list {
    .c-row {
      flex-direction: column !important;
    }
  }
}

.c-add-another {

}


.c-title {
  word-break: break-word;
}

@media (min-width: $breakpoint-md-min) {
  .c-media-col {
    aspect-ratio: 1.333;
    width: 100%;
  }
}
</style>
